export const GET_PIPELINES_REQUEST = "GET_PIPELINES_REQUEST";
export const GET_PIPELINES_SUCCESS = "GET_PIPELINES_SUCCESS";
export const GET_PIPELINES_FAILURE = "GET_PIPELINES_FAILURE";

export const GET_PIPELINE_BY_ID_REQUEST = "GET_PIPELINE_BY_ID_REQUEST";
export const GET_PIPELINE_BY_ID_SUCCESS = "GET_PIPELINE_BY_ID_SUCCESS";
export const GET_PIPELINE_BY_ID_FAILURE = "GET_PIPELINE_BY_ID_FAILURE";

export const CREATE_PIPELINE_REQUEST = "CREATE_PIPELINE_REQUEST";
export const CREATE_PIPELINE_SUCCESS = "CREATE_PIPELINE_SUCCESS";
export const CREATE_PIPELINE_FAILURE = "CREATE_PIPELINE_FAILURE";

export const UPDATE_PIPELINE_REQUEST = "UPDATE_PIPELINE_REQUEST";
export const UPDATE_PIPELINE_SUCCESS = "UPDATE_PIPELINE_SUCCESS";
export const UPDATE_PIPELINE_FAILURE = "UPDATE_PIPELINE_FAILURE";

export const DELETE_PIPELINE_REQUEST = "DELETE_PIPELINE_REQUEST";
export const DELETE_PIPELINE_SUCCESS = "DELETE_PIPELINE_SUCCESS";
export const DELETE_PIPELINE_FAILURE = "DELETE_PIPELINE_FAILURE";

export const RUN_PIPELINE_REQUEST = "RUN_PIPELINE_REQUEST";
export const RUN_PIPELINE_SUCCESS = "RUN_PIPELINE_SUCCESS";
export const RUN_PIPELINE_FAILURE = "RUN_PIPELINE_FAILURE";

export const DRY_RUN_PIPELINE_REQUEST = "DRY_RUN_PIPELINE_REQUEST";
export const DRY_RUN_PIPELINE_SUCCESS = "DRY_RUN_PIPELINE_SUCCESS";
export const DRY_RUN_PIPELINE_FAILURE = "DRY_RUN_PIPELINE_FAILURE";

export const getPipelinesRequest = (datasetId) => ({
    type: GET_PIPELINES_REQUEST,
    params: { datasetId }
});

export const getPipelinesSuccess = (result) => ({
    type: GET_PIPELINES_SUCCESS,
    payload: { result }
});

export const getPipelinesFailure = (error) => ({
    type: GET_PIPELINES_FAILURE,
    payload: { error }
});

export const getPipelineByIdRequest = (pipelineId) => ({
    type: GET_PIPELINE_BY_ID_REQUEST,
    params: { pipelineId }
});

export const getPipelineByIdSuccess = (pipeline) => ({
    type: GET_PIPELINE_BY_ID_SUCCESS,
    payload: { pipeline }
});

export const getPipelineByIdFailure = (error) => ({
    type: GET_PIPELINE_BY_ID_FAILURE,
    payload: { error }
});

export const createPipelineRequest = (pipelineData) => ({
    type: CREATE_PIPELINE_REQUEST,
    params: { pipelineData }
});

export const createPipelineSuccess = (pipeline) => ({
    type: CREATE_PIPELINE_SUCCESS,
    payload: { pipeline }
});

export const createPipelineFailure = (error) => ({
    type: CREATE_PIPELINE_FAILURE,
    payload: { error }
});

export const updatePipelineRequest = (pipelineId, pipelineData) => ({
    type: UPDATE_PIPELINE_REQUEST,
    params: { pipelineId, pipelineData }
});

export const updatePipelineSuccess = (pipeline) => ({
    type: UPDATE_PIPELINE_SUCCESS,
    payload: { pipeline }
});

export const updatePipelineFailure = (error) => ({
    type: UPDATE_PIPELINE_FAILURE,
    payload: { error }
});

export const deletePipelineRequest = (pipelineId) => ({
    type: DELETE_PIPELINE_REQUEST,
    params: { pipelineId }
});

export const deletePipelineSuccess = () => ({
    type: DELETE_PIPELINE_SUCCESS
});

export const deletePipelineFailure = (error) => ({
    type: DELETE_PIPELINE_FAILURE,
    payload: { error }
});

export const runPipelineRequest = (pipelineId) => ({
    type: RUN_PIPELINE_REQUEST,
    params: { pipelineId }
});

export const runPipelineSuccess = (result) => ({
    type: RUN_PIPELINE_SUCCESS,
    payload: { result }
});

export const runPipelineFailure = (error) => ({
    type: RUN_PIPELINE_FAILURE,
    payload: { error }
});

export const RESET_PIPELINE_STATE = "RESET_PIPELINE_STATE";

export const resetPipelineState = () => ({
    type: RESET_PIPELINE_STATE
});

export const dryRunPipelineRequest = (pipelineId) => ({
    type: DRY_RUN_PIPELINE_REQUEST,
    params: { pipelineId }
});

export const dryRunPipelineInlineRequest = (datasetId, steps) => ({
    type: DRY_RUN_PIPELINE_REQUEST,
    params: { datasetId, steps }
});

export const dryRunPipelineSuccess = (result) => ({
    type: DRY_RUN_PIPELINE_SUCCESS,
    payload: { result }
});

export const dryRunPipelineFailure = (error) => ({
    type: DRY_RUN_PIPELINE_FAILURE,
    payload: { error }
});
